import React, { useState, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import _ from "lodash";

import Uploadfiles from "./UploadFiles";
import ViewFiles from "./ViewFiles";

//Apis
import driverApi from "Services/Driver";

const Documents = ({
  driverId,
  setsubmitButton,
  setSkipButton,
  entityLabel = "Driver",
  userType = "DRIVER",
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const entityLabelLower = entityLabel.toLowerCase();

  useEffect(() => {
    setsubmitButton(true);
    setSkipButton(true);
  }, [setsubmitButton, setSkipButton]);

  const [row, setRow] = useState([]);

  const [uploadFilesModal, setUploadFilesModal] = useState(false);
  const [viewFilesModal, setViewFilesModal] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [documentData, setDocumentData] = useState(null);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsInitialData, setDocumentsInitialData] = useState([]);

  const handleOpenUploadFilesModal = (row) => {
    console.log(row);
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setUploadFilesModal(true);
  };

  const handleCloseUploadFilesModal = () => {
    getDriverDocuments();
    setDocumentData(null);
    setUploadFilesModal(false);
  };

  const handleCloseViewFilesModal = () => {
    getDriverDocuments();
    setDocumentData(null);
    setViewFilesModal(false);
  };

  const handleUploadDocument = (file) => {
    if (!documentData || !file || !driverId) {
      return Promise.reject(
        new Error(`Missing ${entityLabelLower} document context`),
      );
    }

    dispatch(showLoader("Loading please wait..."));

    const formData = new FormData();
    formData.append("image", file);
    formData.append("driver_id", driverId);
    formData.append("document_type_id", documentData.documentId);

    const onSuccess = (res) => {
      dispatch(hideLoader());

      if (res?.status === 200 || res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "File uploaded successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          }),
        );
      }

      return res;
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to upload the file",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        }),
      );
      return Promise.reject(err);
    };

    return driverApi
      .updateDriverDocument(formData)
      .then(onSuccess)
      .catch(onFailure);
  };

  // View modal
  const handleOpenViewFilesModal = (row) => {
    setDocumentId(row?.documentId);
    setDocumentData(row);
    setViewFilesModal(true);
  };

  //Get documents

  const getDriverDocumentsTypes = () => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());

      if (res?.status === 200) {
        console.log(res?.data?.data);
        const documentTypes = Array.isArray(res?.data?.data)
          ? res?.data?.data
          : Array.isArray(res?.data?.data?.data)
            ? res?.data?.data?.data
            : [];

        setDocumentsInitialData(documentTypes);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());

      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        }),
      );

      console.log("error fetch service area", err);
    };

    driverApi.getDocumentsTypes(userType).then(onSuccess).catch(onFailure);
  };

  const getDriverDocuments = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDriverDocumentsData(res?.data?.data?.driverDocuments);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        }),
      );
      //console.log("error fetch service area", err);
    };

    if (validation) {
      driverApi
        .getDriverDocumentsByDriverId(driverId, { userType })
        .then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    getDriverDocumentsTypes();
    getDriverDocuments();
  }, []);
  // Handle driver delete document

  const handleDeleteDocument = (row) => {
    var result = window.confirm("Do you want to Delete?");
    if (result) {
      dispatch(showLoader("Loading please wait..."));

      let data = {
        document_type_id: row?.documentId,
        user_id: driverId,
      };

      const onSuccess = (res) => {
        dispatch(hideLoader());
        if (res?.data?.status === true) {
          dispatch(
            showSnackbar({
              message: "Document deleted successfully",
              autoHideDuration: 3000,
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            }),
          );
        }
        getDriverDocuments();
      };
      const onFailure = (err) => {
        dispatch(hideLoader());
        showSnackbar({
          message: "Failed to delete the document",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        });
      };

      driverApi.deleteDriverDocument({ ...data }).then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    const documentTypes = Array.isArray(documentsInitialData)
      ? documentsInitialData
      : [];

    const uploadedDocuments = Array.isArray(driverDocumentsData)
      ? driverDocumentsData
      : [];
    console.log(documentTypes);
    console.log(uploadedDocuments);
    const combinedArray = documentTypes.map((item1) => {
      const normalize = (str) =>
        (str ?? "")
          .trim()
          .toLowerCase()
          .replace(/[’‘]/g, "'") // normalise les apostrophes typographiques
          .replace(/\s+/g, " "); // normalise les espaces multiples/insécables

      const matchingDocument = uploadedDocuments.find((item2) => {
        return (
          normalize(item1.documentTypeAlias) ===
          normalize(item2.documentDescription)
        );
      });

      const documentId = item1.id ?? 0;
      const documentPath = matchingDocument
        ? matchingDocument.documentPath
          ? matchingDocument.documentPath
          : ""
        : "";
      const status = matchingDocument
        ? matchingDocument.documentPath
          ? matchingDocument.status
          : "NO DOCUMENT"
        : "NO DOCUMENT";

      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
      };
    });
    setRow(combinedArray);
  }, [driverDocumentsData, documentsInitialData]);

  const dataRows = _.map(row || [], (data, index) => ({
    id: index + 1,
    sno: index + 1,
    documentId: data?.documentId,
    documentType: data?.documentType,
    documentTypeAlias: data?.documentTypeAlias,
    file: data?.file,
    status: data?.status,
    data: data,
  }));
  console.log(dataRows);

  // useEffect(() => {
  //   const allApproved = _.every(row, (doc) => doc?.status === "APPROVED");

  //   setsubmitButton(allApproved);
  //   setSkipButton(allApproved);
  // }, [row]);

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      minWidth: 180,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "documentType",
      headerName: "Document Type",
      minWidth: 200,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">
                {params?.row?.documentType}
              </Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.status}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 320,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.actionBtnWrapper}>
              {params?.row?.file == "" && (
                <section className={classes.uploadButton}>
                  <Button
                    variant="contained"
                    style={{ fontSize: "13px", borderRadius: "8px" }}
                    onClick={() => handleOpenUploadFilesModal(params?.row)}
                  >
                    Upload
                  </Button>
                </section>
              )}
              {params?.row?.file != "" && (
                <>
                  <section className={classes.viewButton}>
                    <Button
                      variant="outlined"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleOpenViewFilesModal(params?.row)}
                    >
                      View
                    </Button>
                  </section>

                  <section className={classes.deleteButton}>
                    <Button
                      variant="contained"
                      style={{ fontSize: "13px", borderRadius: "8px" }}
                      onClick={() => handleDeleteDocument(params?.row)}
                    >
                      Delete
                    </Button>
                  </section>
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              rows={dataRows}
              columns={columns}
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
            />
          </section>
        </Grid>
        <Uploadfiles
          openDialog={uploadFilesModal}
          handleClose={handleCloseUploadFilesModal}
          onUploadDocument={handleUploadDocument}
        />
        <ViewFiles
          openDialog={viewFilesModal}
          handleClose={handleCloseViewFilesModal}
          driverId={driverId}
          documentId={documentId}
          documentData={documentData}
        ></ViewFiles>
      </Grid>
    </>
  );
};

export default Documents;
